import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Web3 from "web3";
import Loader from "../loader";
import UiButton from "../../components/button";

import DateTimePicker from "react-datetime-picker";
import "react-toastify/dist/ReactToastify.css";
import ERC20ABI from "../../utils/abi/ERC20.json";
import { toast } from "react-toastify";
import { useGlobal } from "../../context/globalContext";
import {
  FailureToast,
  SuccessToast,
  ToastOptions,
} from "../../utils/constants";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { getAllVerifiedCashBalances } from "../../utils/helpers";
import { Security } from "@verified-network/verified-sdk";

function RefundsModal(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    isUpdate,
    setIsUpdate,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [value, onChange] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  const scheduleSnapshot = async () => {
    const currentDate = Math.floor(new Date().getTime() / 1000).toString();
    value.setSeconds(0);
    let dateTime = Math.floor(value.getTime() / 1000).toString();
    if (dateTime < currentDate) {
      toast.error(
        FailureToast("", "Select correct time(future date)"),
        ToastOptions
      );
      return;
    }
    const securityTokenContract = new Security(signer, props.data.security);

    setLoading(true);
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await securityTokenContract._getMeeQuote(
          cashTokens[0]?.address,
          "scheduleSnapshot",
          [dateTime?.toString()]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await securityTokenContract
        .scheduleSnapshot(
          dateTime?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            toast.success(SuccessToast(), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
            setIsUpdate(!isUpdate);
          } else {
            toast.error(FailureToast(), ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      setLoading(false);
      toast.error(FailureToast(), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Time</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DateTimePicker onChange={onChange} value={value} />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && chainId && account && signer) {
                    scheduleSnapshot();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Schedule"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function ScheduleSnapshot(props) {
  return <RefundsModal {...props} />;
}
